module.exports = __webpack_public_path__ + "static/media/Al-Raihann-logo.109ad6b2.webp";